// components/translation/TranslationProgress.js
import React from 'react';
import { Loader } from 'lucide-react';

const TranslationProgress = ({ messages = [], isTranslating = false }) => {
  // Only show the most recent messages (last 5)
  const recentMessages = messages.slice(-5);
  
  return (
    <div className="mt-3 bg-gray-50 border border-blue-100 rounded-md p-3 max-h-40 overflow-y-auto">
      <h4 className="text-sm font-medium text-blue-700 mb-2 flex items-center">
        {isTranslating && <Loader className="w-4 h-4 animate-spin mr-2" />}
        Translation Progress
      </h4>
      
      {recentMessages.length === 0 ? (
        <p className="text-sm text-gray-500 italic">
          {isTranslating ? 'Starting translation process...' : 'No translation in progress'}
        </p>
      ) : (
        <ul className="text-xs space-y-1">
          {recentMessages.map((msg, index) => (
            <li key={index} className="text-gray-700 border-l-2 border-blue-300 pl-2 py-1">
              {msg}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TranslationProgress;